extendNative(Array.prototype, 'remove', function(item) {
  const ix = this.indexOf(item)
  if (ix > -1) {
    this.splice(ix, 1)
  }
})

function extendNative(prototype, name, fn) {
  if (prototype[name]) {
    return
  }
  prototype[name] = fn
}
